(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c67"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c67"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("r9Hbx", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $051a0b1000bbb3d3$export$6503ec6e8aabbaf; }, function (v) { return $051a0b1000bbb3d3$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $051a0b1000bbb3d3$export$f7ad0328861e2f03; }, function (v) { return $051a0b1000bbb3d3$export$f7ad0328861e2f03 = v; });
var $051a0b1000bbb3d3$export$6503ec6e8aabbaf;
var $051a0b1000bbb3d3$export$f7ad0328861e2f03;
"use strict";
var $051a0b1000bbb3d3$var$mapping = new Map();
function $051a0b1000bbb3d3$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$051a0b1000bbb3d3$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $051a0b1000bbb3d3$var$resolve(id) {
    var resolved = $051a0b1000bbb3d3$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$051a0b1000bbb3d3$export$6503ec6e8aabbaf = $051a0b1000bbb3d3$var$register;
$051a0b1000bbb3d3$export$f7ad0328861e2f03 = $051a0b1000bbb3d3$var$resolve;

});

parcelRegister("aj79h", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $78113955f5a8b562$export$bdfd709ae4826697; }, function (v) { return $78113955f5a8b562$export$bdfd709ae4826697 = v; });
var $78113955f5a8b562$export$bdfd709ae4826697;
var $78113955f5a8b562$export$c9e73fbda7da57b6;
var $78113955f5a8b562$export$5a759dc7a1cfb72a;
"use strict";
var $78113955f5a8b562$var$bundleURL = {};
function $78113955f5a8b562$var$getBundleURLCached(id) {
    var value = $78113955f5a8b562$var$bundleURL[id];
    if (!value) {
        value = $78113955f5a8b562$var$getBundleURL();
        $78113955f5a8b562$var$bundleURL[id] = value;
    }
    return value;
}
function $78113955f5a8b562$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $78113955f5a8b562$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $78113955f5a8b562$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $78113955f5a8b562$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$78113955f5a8b562$export$bdfd709ae4826697 = $78113955f5a8b562$var$getBundleURLCached;
$78113955f5a8b562$export$c9e73fbda7da57b6 = $78113955f5a8b562$var$getBaseURL;
$78113955f5a8b562$export$5a759dc7a1cfb72a = $78113955f5a8b562$var$getOrigin;

});

var $5ec5b2bf1118addd$exports = {};


(parcelRequire("r9Hbx")).register((parcelRequire("aj79h")).getBundleURL("dwYZa"), JSON.parse('["dwYZa","index.4ec6eaaa.js","640Ws","application.0a08054d.js","esb2b","bg.42ce76ab.jpg","1OqVM","ADMIN.c5426ae8.jpg","4qrGx","APP.768063a7.jpg","30Qba","EVENTS.fc055251.jpg","2hx97","HEROES.f6aceb76.jpg","hFV1w","PARENTS.dcc3a2e9.jpg","hOaKY","PLAY.206b9901.jpg","2bckt","PROMISE.c0103f72.jpg","8NpTg","RULES.ecdcc89b.jpg","1UH78","application.1cd4266a.js","aJxsw","application.916fd179.css","2GZpY","batman.5b8e1050.png","2U1Yy","black_panther.cb848b80.png","i4hDV","flash.5ac9a66c.png","4RWrZ","hulk.14e8509b.png","3oshq","iron_man.97c262be.png","ampTG","spiderman.e2295677.png","dVmRr","wolverine.6acf5939.png","kJz6K","batwoman.34080648.png","OyTjR","black_widow.803b452f.png","clcGq","captain_marvel.a971ec72.png","9tlna","she-hulk.2acf9bfa.png","13WFl","spidergwen.662a1233.png","jQi2e","storm.f2f1255d.png","bWUOj","login.97bacaf6.js","hjiJU","recovery.778c5e50.js","MlAVV","signup.687a2793.js","5JPFz","household.e750de56.js","aixVb","sw.js","eqOZN","index.18990735.css"]'));

})();
//# sourceMappingURL=index.runtime.a235b6bd.js.map
